import { agruparRetorno } from '@/utils/agruparRetorno';
import { IGerarRetornoBradesco, IDocumentoRetornoBradesco } from './types';

export function gerarRetorno({ dados }: IGerarRetornoBradesco){
  try {
    const { arquivo } = dados;
    const documentos: IDocumentoRetornoBradesco[] = [];

    let index = 0;

    for (const item of arquivo) {
      let linha = item;

      const banco = linha.substring(0, 3);
      const codigoRetorno = linha.substring(15, 17);

      if (
        (banco === '001' || banco === '085') &&
        (codigoRetorno === '06' || codigoRetorno === '17')
      ) {
        let segmento = linha.substring(13, 14);

        if (segmento === 'T') {
          let tipoDocumento: string = '';
          let idDocumento: string = '';

          const linhaDoc = linha.substring(105, 130).trimEnd();

          if (linhaDoc.includes('-')) {
            [tipoDocumento, idDocumento] = linha.split('-');
          } else {
            idDocumento = linhaDoc;
          }

          const especie = tipoDocumento.length ? tipoDocumento : 'INDEFINIDO';

          linha = arquivo[index + 1];
          segmento = linha.substring(13, 14);

          if (segmento === 'U') {
            const valorAbatimentoString = linha.substring(47, 62);
            const valorAbatimento = Number(valorAbatimentoString) / 100;

            const valorDescontoString = linha.substring(32, 47);
            const valorDesconto = Number(valorDescontoString) / 100;

            const valorPagoString = linha.substring(77, 92);
            const valorPago = Number(valorPagoString) / 100;

            const valorJurosString = linha.substring(17, 32);
            const valorJuros = Number(valorJurosString) / 100;

            const valorMulta = 0;
            const descontos = valorAbatimento + valorDesconto;
            const valorTotal = valorPago - valorJuros + descontos;

            const documento: IDocumentoRetornoBradesco = {
              id_documento: idDocumento,
              especie,
              valor: valorTotal,
              valor_desconto: 0,
              valor_juros: 0,
              valor_multa: 0,
              valor_total: 0,
              data: new Date(),
            };

            documentos.push(documento);
          }
        }
      }

      index++;
    }

    const documentoAgrupado = agruparRetorno<IDocumentoRetornoBradesco>(documentos);
    return documentoAgrupado;
  } catch (error) {
    console.log(error);
    return null;
  }
}
